/**
 * What the Issues list reads to tell whether an issue cost the page something: organic sessions and
 * Search Console impressions. A row carries a reading on each measure the workspace has; the row charts
 * read impressions, or sessions without Search Console.
 */
export const DEFAULT_MEASURE = "impressions";

export const MEASURES = {
    sessions: {
        key: "sessions",
        label: "Sessions",
        noun: "sessions",
        chartLabel: "Organic sessions",
        site: { key: "sessions", name: "organic sessions" },
        available: ({ source }) => source === "sessions",
        spark: (page) => page.spark,
        readingOf: (issue) => issue.lossCheck
            ? { pivot: issue.pivot, lossCheck: issue.lossCheck, lost: issue.trafficLost }
            : null,
    },
    impressions: {
        key: "impressions",
        label: "Impressions",
        noun: "impressions",
        chartLabel: "Search Console impressions",
        site: { key: "impressions", name: "Search Console impressions" },
        available: ({ searchConsole }) => searchConsole,
        spark: (page) => page.impressionsSpark,
        readingOf: (issue) => issue.impressions,
    },
};

export const measureOf = (key) => MEASURES[key] || MEASURES[DEFAULT_MEASURE];

/** The keys of the measures the fixture has. */
export const measuresOf = (fixture) => Object.keys(MEASURES).filter((key) => MEASURES[key].available(fixture));

/** The measure the row charts and the KPI bar open on: Impressions, else the measure the fixture has. */
export const measureKeyOf = (measures) => (measures.includes(DEFAULT_MEASURE) ? DEFAULT_MEASURE : measures[0] ?? DEFAULT_MEASURE);
